// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {AssessableItem, AssessableItemGroup, ChecklistItem} from "@models";
import {Translations} from "@translations";

export interface DialogData_MoveChecklistItemToGroupInput<T extends AssessableItem> extends MatDialogDataBaseInput {
	checklistGroups: AssessableItemGroup<T>[];
}

export interface DialogData_MoveChecklistItemToGroupOutput<T extends AssessableItem> extends MatDialogDataBaseOutput {
	selectedChecklistGroup?: AssessableItemGroup<T>;
	selectedChecklistGroupIndex?: number;
}

@Component({
	selector: "sim-move-checklist-item-to-group-dialog",
	templateUrl: "./move-checklist-item-to-group-dialog.component.html",
	styleUrls: ["./move-checklist-item-to-group-dialog.component.scss"],
	standalone: false,
})
export class MoveChecklistItemToGroupDialogComponent<T extends AssessableItem> extends BasicMaterialDialog<
	MoveChecklistItemToGroupDialogComponent<T>,
	DialogData_MoveChecklistItemToGroupInput<T>,
	DialogData_MoveChecklistItemToGroupOutput<T>
> {
	T = Translations;

	public selectedChecklistGroup: AssessableItemGroup<T>;
	public selectedChecklistGroupIndex: number;

	constructor(_injector: Injector) {
		super(_injector);
	}

	ngOnInit(): void {}

	checklistGroupSelected(checklistGroup: AssessableItemGroup<T>, checklistGroupIndex: number) {
		this.selectedChecklistGroup = checklistGroup;
		this.selectedChecklistGroupIndex = checklistGroupIndex;
	}

	moveChecklistItem() {
		this.close({
			action: "ok",
			selectedChecklistGroup: this.selectedChecklistGroup,
			selectedChecklistGroupIndex: this.selectedChecklistGroupIndex,
		});
	}
}
